export default {
  primary: "#1B3D8E",
  secondary: "#CADC43",
};
